import React from "react";
import "./Badge.css";

interface BadgeProps {
  number: number;
}

const Badge: React.FC<BadgeProps> = ({ number }) => {
  return <span className="badge">{Math.min(number, 99)}</span>;
};

export default Badge;
